import { Navigate, Route, Routes } from 'react-router'
import { PageNotFoundRoutes } from 'entities/ExportRouters'
import { QuestionnairePage } from 'pages/settings/pages/compliance/pages/questionnaire/ui/questionnairePage'
import { QuestionnaireLayout } from 'pages/settings/pages/compliance/pages/questionnaire/layout/questionnaireLayout'

export const QuestionnaireRouter = () => {
  return (
    <Routes>
      <Route element={<QuestionnaireLayout />}>
        <Route path={'/'} element={<QuestionnairePage />} />
        <Route path='*' element={<Navigate to={`/${PageNotFoundRoutes.root}`} replace />} />
      </Route>
    </Routes>
  )
}
